var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loading-effect"},[(_vm.indicator)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.indicator))]):_c('CircularAnimation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }